import { Component, Input } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'get-authenticator',
	template: require('./get-authenticator.component.html'),
	styles: [require('./get-authenticator.component.scss')]
})
export class GetAuthenticatorComponent {
	@Input() QRImage: string;
	@Input() code: string;

	constructor(private messageService: MessageService) {}

	copyToClipboard(ev): void {
		ev.preventDefault();
		this.messageService.showToaster('i_0', 'twoFa');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/2fa/modals/two-fa-setup-modal/get-authenticator/get-authenticator.component.ts